<template>
  <div class="modal fade transfer-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-info text-white">
          <h5 class="modal-title text-white fw-bold">
            <i class="mdi mdi-transfer me-2"></i>
            Transfer Plot Ownership
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <!-- Current Plot Info -->
          <div class="card mb-4">
            <div class="card-header bg-light">
              <h6 class="mb-0 fw-bold">Current Plot Information</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <strong>Plot Number:</strong> {{ plot.plotNumber }}<br>
                  <strong>Zone:</strong> {{ plot.zone }}<br>
                  <strong>Location:</strong> {{ plot.subCountyName }}, {{ plot.wardName }}
                </div>
                <div class="col-md-6">
                  <strong>Current Owner:</strong> {{ plot.ownerNames }}<br>
                  <strong>Phone:</strong> {{ plot.ownerPhoneNo || '-' }}<br>
                  <strong>Current Balance:</strong>
                  <span :class="plot.currentBalance > 0 ? 'text-danger' : 'text-success'">
                    KES {{ numberFormat(plot.currentBalance) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Transfer Form -->
          <div class="card">
            <div class="card-header bg-warning text-dark">
              <h6 class="mb-0 fw-bold">New Owner Details</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">New Owner Name <span class="text-danger">*</span></label>
                    <input v-model="transferForm.ownerName" type="text" class="form-control" placeholder="Enter new owner's name">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">ID Number <span class="text-danger">*</span></label>
                    <input v-model="transferForm.ownerID" type="text" class="form-control" placeholder="Enter ID number">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">Phone Number</label>
                    <input v-model="transferForm.ownerPhone" type="tel" class="form-control" placeholder="e.g., 0712345678">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">Email Address</label>
                    <input v-model="transferForm.ownerEmail" type="email" class="form-control" placeholder="Enter email">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">Bill/Invoice Number</label>
                    <input v-model="transferForm.billNo" type="text" class="form-control" placeholder="Transfer fee bill number">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">Minutes Number</label>
                    <input v-model="transferForm.minutesNumber" type="text" class="form-control" placeholder="Approval minutes reference">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group mb-3">
                    <label class="form-label fw-semibold">Supporting Document</label>
                    <input type="file" ref="fileInput" @change="handleFileChange" class="form-control" accept=".pdf,.jpg,.jpeg,.png">
                    <small class="text-muted">Upload transfer approval document (PDF or image)</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Warning Alert -->
          <div class="alert alert-warning mt-3">
            <i class="mdi mdi-alert me-2"></i>
            <strong>Important:</strong> This transfer request will require approval before the ownership change takes effect.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button @click="submitTransfer" type="button" class="btn btn-info" :disabled="submitting">
            <span v-if="submitting">
              <span class="spinner-border spinner-border-sm me-2"></span>Submitting...
            </span>
            <span v-else>
              <i class="mdi mdi-send me-2"></i>Submit Transfer Request
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, plotRent } from "@/api";

export default {
  name: 'PlotTransferModal',
  props: {
    plot: { type: Object, default: () => ({}) }
  },
  emits: ['transfer-complete'],
  data() {
    return {
      transferForm: {
        ownerName: '',
        ownerID: '',
        ownerPhone: '',
        ownerEmail: '',
        billNo: '',
        minutesNumber: ''
      },
      selectedFile: null,
      submitting: false
    }
  },
  watch: {
    plot() {
      this.resetForm();
    }
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },

    submitTransfer() {
      if (!this.transferForm.ownerName) {
        alert("New owner name is required");
        return;
      }
      if (!this.transferForm.ownerID) {
        alert("New owner ID number is required");
        return;
      }

      if (!confirm(`Transfer plot ${this.plot.plotNumber} to ${this.transferForm.ownerName}?`)) return;

      this.submitting = true;

      const data = new FormData();
      data.append("function", "transferRequest");
      data.append("id", this.plot.id);
      data.append("ownerName", this.transferForm.ownerName);
      data.append("ownerID", this.transferForm.ownerID);
      data.append("ownerPhone", this.transferForm.ownerPhone || '');
      data.append("ownerEmail", this.transferForm.ownerEmail || '');
      data.append("billNo", this.transferForm.billNo || '');
      data.append("minutesNumber", this.transferForm.minutesNumber || '');
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      if (this.selectedFile) {
        data.append("fileToUpload", this.selectedFile);
      }

      execute(data, plotRent)
          .then((res) => {
            this.submitting = false;
            if (res.data.success) {
              alert("Transfer request submitted successfully. Awaiting approval.");
              this.$emit('transfer-complete');
              this.closeModal();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.submitting = false;
            alert("Error: " + e.message);
          });
    },

    resetForm() {
      this.transferForm = {
        ownerName: '',
        ownerID: '',
        ownerPhone: '',
        ownerEmail: '',
        billNo: '',
        minutesNumber: ''
      };
      this.selectedFile = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },

    closeModal() {
      const modal = document.querySelector('.transfer-modal');
      if (modal) {
        const instance = bootstrap.Modal.getInstance(modal);
        if (instance) instance.hide();
      }
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    }
  }
}
</script>